export enum MessageFolderEnum {
  INBOX = "inbox",
  ARCHIVE = "archive",
  OUTBOX = "outbox",
  JUNK = "junk"
}
